import { render, staticRenderFns } from "./manageDetails.vue?vue&type=template&id=5b3c0867&scoped=true"
import script from "./manageDetails.vue?vue&type=script&lang=js"
export * from "./manageDetails.vue?vue&type=script&lang=js"
import style0 from "./manageDetails.vue?vue&type=style&index=0&id=5b3c0867&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3c0867",
  null
  
)

export default component.exports